module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "otherbooks",
    attrs: {
      "id": "adc"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NONFICTION TITLES BY CAROLLY ERICKSON")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Records of Medieval Europe"), _c('br'), _vm._v("The Medieval Vision"), _c('br'), _vm._v("Civilization and Society in the West"), _c('br'), _vm._v("Bloody Mary"), _c('br'), _vm._v("Great Harry"), _c('br'), _vm._v("The First Elizabeth"), _c('br'), _vm._v("Mistress Anne"), _c('br'), _vm._v("Our Tempestuous Day"), _c('br'), _vm._v("Bonnie Prince Charlie"), _c('br'), _vm._v("To the Scaffold"), _c('br'), _vm._v("Great Catherine"), _c('br'), _vm._v("Her Little Majesty"), _c('br'), _vm._v("Arc of the Arrow"), _c('br'), _vm._v("Josephine"), _c('br'), _vm._v("Alexandra"), _c('br'), _vm._v("Royal Panoply"), _c('br'), _vm._v("Lilibet"), _c('br'), _vm._v("The Girl from Botany Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FICTION")]), _c('br'), _c('em', [_vm._v("The Hidden Diary of Marie Antoinette")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9925be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312316433_epub_adc_r1.vue
// module id = 57
// module chunks = 0